import { format } from 'date-fns'

export const timeOptions: string[] = [
  '00:00',
  '00:15',
  '00:30',
  '00:45',
  '01:00',
  '01:15',
  '01:30',
  '01:45',
  '02:00',
  '02:15',
  '02:30',
  '02:45',
  '03:00',
  '03:15',
  '03:30',
  '03:45',
  '04:00',
  '04:15',
  '04:30',
  '04:45',
  '05:00',
  '05:15',
  '05:30',
  '05:45',
  '06:00',
  '06:15',
  '06:30',
  '06:45',
  '07:00',
  '07:15',
  '07:30',
  '07:45',
  '08:00',
  '08:15',
  '08:30',
  '08:45',
  '09:00',
  '09:15',
  '09:30',
  '09:45',
  '10:00',
  '10:15',
  '10:30',
  '10:45',
  '11:00',
  '11:15',
  '11:30',
  '11:45',
  '12:00',
  '12:15',
  '12:30',
  '12:45',
  '13:00',
  '13:15',
  '13:30',
  '13:45',
  '14:00',
  '14:15',
  '14:30',
  '14:45',
  '15:00',
  '15:15',
  '15:30',
  '15:45',
  '16:00',
  '16:15',
  '16:30',
  '16:45',
  '17:00',
  '17:15',
  '17:30',
  '17:45',
  '18:00',
  '18:15',
  '18:30',
  '18:45',
  '19:00',
  '19:15',
  '19:30',
  '19:45',
  '20:00',
  '20:15',
  '20:30',
  '20:45',
  '21:00',
  '21:15',
  '21:30',
  '21:45',
  '22:00',
  '22:15',
  '22:30',
  '22:45',
  '23:00',
  '23:15',
  '23:30',
  '23:45',
]

export const dateToTimeOptions = (date: Date) => {
  return `${(date.getHours() < 10 ? '0' : '') + date.getHours()}:${
    (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
  }`
}

export const toModalDateString = (date: Date) => {
  return date.toISOString().slice(0, 10)
}

export const timpestampToDate = (time: number | undefined): Date => {
  if (time) {
    return new Date(
      new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(time),
    )
  } else {
    return new Date()
  }
}

export const timeOptionToNumber = (option: string): number => {
  const [hours, minutes] = option.split(':')
  return parseInt(hours) * 3600 + parseInt(minutes) * 60
}

export const setDateHourAndMinutes = (date: string, time: string) => {
  const timeDate = time.split(':')
  const dateDate = new Date(date)

  if (parseInt(timeDate[0]) < 6) {
    dateDate.setDate(dateDate.getDate() + 1)
  }

  const finalDate = new Date(
    dateDate.getFullYear(),
    dateDate.getMonth(),
    dateDate.getDate(),
    parseInt(timeDate[0]),
    parseInt(timeDate[1]),
  )
  return finalDate.valueOf()
}

export const formatDate = (timestamp: string | number) => {
  return format(new Date(timestamp), 'yyyy-MM-dd')
}

export const formatDateTime = (
  timestamp: string | number,
  formatString = 'yyyy-MM-dd HH:mm',
) => {
  if (!timestamp) return '-'
  try {
    return format(new Date(timestamp), formatString)
  } catch (err) {
    console.log(err)
    return ''
  }
}

export const increaseByOneDay = (date: number): number => {
  const newDate = timpestampToDate(date)

  return newDate.setDate(newDate.getDate() + 1).valueOf()
}

export const sanitizeDate = (timestamp: Date) => {
  if (!timestamp) return '-'
  const date = new Date(timestamp)
  return `${date.getFullYear()}-${
    (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1)
  }-${(date.getDate() < 10 ? '0' : '') + date.getDate()} ${
    (date.getHours() < 10 ? '0' : '') + date.getHours()
  }:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()}`
}

export const remainingDays = (expirationDate: number) => {
  return expirationDate - new Date().valueOf()
}

export const calcDaysBetweenTwoDates = (date1: number, date2: number) => {
  const difference = date1 - date2
  return Math.ceil(difference / (1000 * 60 * 60 * 24))
}

export const secondsToMinutes = (time: number) => {
  const minutes = Math.floor(time / 60)
  const seconds = time - minutes * 60
  return `${minutes === 0 ? '0' : minutes}:${
    seconds < 10 ? `0${seconds}` : seconds
  }`
}
